<template>
  <!-- Root stays where Vue rendered it; only the inner content is handed to Google's InfoWindow -->
  <div>
    <div ref="content" class="pa-0">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "MapInfoWindow",
  props: {
    lat: { required: true },
    lng: { required: true },
    disableAutoPan: Boolean,
  },
  watch: {
    lat: function () {
      this.infoW.close();
      this.openInfoWindow();
    },
  },
  data: function () {
    return {
      infoW: null,
    };
  },
  mounted() {
    this.openInfoWindow();
  },
  beforeDestroy() {
    this.infoW.close();
  },
  methods: {
    openInfoWindow: function () {
      this.$parent.getMap((map) => {
        (this.infoW = new window.google.maps.InfoWindow({
          pixelOffset: new window.google.maps.Size(0, -20),
          position: new window.google.maps.LatLng(this.lat, this.lng),
          content: this.$refs.content,
          disableAutoPan: this.disableAutoPan,
        })),
          this.infoW.open(map);
        this.infoW.addListener("closeclick", () => {
          this.$emit("close_infowindow");
        });
      });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
::v-deep .gm-style-iw + div {
  display: none;
}
</style>
